import React, { Component } from 'react'
import LoginPage from './Components/LoginPage/LoginPage'
import './Login.css'
import './CCSCasesStyles.css'
import logo from '../../assets/cdmCases.png'
import UnauthenticatedHandler from '../UnauthenticatedHandler/UnauthenticatedHandler'
import ForgotPassword from './Components/ForgotPassword/ForgotPassword'
import TermsOfService from './Components/TermsOfService/TermsOfService'
import DemoSignup from './Components/DemoSignup/DemoSignup'
import fetchSubmitLogs from '../../Functions/FetchSubmitLogs'
import logFetchError from '../../Functions/LogFetchError'

export default class Login extends Component {
    constructor() {
        super()
        this.state = {
            loginPageDisplayed: 'login',
            email: '',
            password: '',
            demoMessage: '',
            systemMessage: '',
            resetMessage: '',
            demoError: '',
            firstName: '',
            lastName: '',
            emailConfirmation: '',
            demoHear: 'google',
            otherHear: '',
            loginError: '',
            displayCaptcha: false,
            captchaCompleted: false,
            authenticationError: false,
            loginErrorCount: 0,
            // Activate Early
            futureActivationDate: null,
            activateEarlyConfirmText: '',
            activateEarlyFetchOutstanding: false,
            activateEarlyResponse: '',
            activateEarlyError: '',
        }
    }

    fetchForgotPassword = () => {
        fetch(`${this.props.route}/forgotpassword.webapi`, {
			method: 'POST',
			headers: {
				'Content-Type': 'text/plain',
			},
			body: JSON.stringify({
				email: this.state.email,
			})
		})
		.then(response => response.text())
		.then(result => {

			//Attempt sending logs
			fetchSubmitLogs(null, null)

			result = result.replace('{', '');
			result = result.replace('}', '');
			this.setState({resetMessage: result});
		})
		.catch(error => {
			if (error.toString().includes('SyntaxError: Unexpected token U in JSON at position 1') || error.toString().includes('SyntaxError: JSON Parse error: Expected \'}\'')) {
				this.setState({authenticationError: true})
			}
			console.log('error', error);
			logFetchError(error, null, null, 'fetchForgotPassword')
		});
    }

    fetchDemoSignup = (e) => {
        e.preventDefault()
		let hear;
		if (this.state.demoHear === 'other') {
			hear = this.state.otherHear;
		}
		else {
			hear = this.state.demoHear;
		}
		if (this.state.email !== this.state.emailConfirmation) {
			return this.setState({demoError: 'Emails do not match. Please check that you\'ve spelled everything correctly.'})
		}
		fetch(`${this.props.route}/demosignup.webapi`, {
			method: 'POST',
			headers: {
				'Content-Type': 'text/plain',
			},
			body: JSON.stringify({
				customerFirstName: this.state.firstName,
				customerLastName: this.state.lastName,
				customerEmail: this.state.email,
				whereDidYouHear: hear,
			})
		})
		.then(response => response.text())
		.then(result => {

			//Attempt sending logs
			fetchSubmitLogs(null, null)
			console.log(result)
			if (result.includes('signupError:')) {
				this.setState({demoError: result.slice(13, result.length)})
			} else {
				result = result.replace('{', '');
				result = result.replace('}', '');
				this.setState({demoMessage: result, loginPageDisplayed: 'login', demoError: ''});
			}
		})
		.catch(error => {
			console.log('error', error);
			logFetchError(error, null, null, 'fetchDemoSignup')
		});
    }

    fetchLogin = () => {
        if (!this.state.displayCaptcha || (this.state.displayCaptcha && this.state.captchaCompleted)) {

			fetch(`${this.props.route}/login.webapi`, {
				method: 'POST',
				headers: {
					'Content-Type': 'text/plain',
				},
				body: JSON.stringify({
					userName: this.state.email,
					password: this.state.password,
				})
			})
			.then(response => response.text())
			.then(result => {

				//Attempt sending logs
				fetchSubmitLogs(null, null)
				if (result.includes('Token')) {
                    this.props.updateUserData(JSON.parse(result))
				}
				else if (result.includes('not scheduled to be activated until')) {
					// Extract the future activation date from the plain-text response
					const dateMatch = result.match(/until\s+([A-Za-z]+ \d{1,2},\s*\d{4})/);
					const futureActivationDate = dateMatch
						? new Date(dateMatch[1]).toISOString()
						: null;
					this.setState({
						loginPageDisplayed: 'activateEarly',
						futureActivationDate,
					});
				}
				else {
					result = result.replace('{', '');
					result = result.replace('}', '');
					this.setState({
						loginError: result,
						loginErrorCount: this.state.loginErrorCount + 1,
					});
					if (this.state.loginErrorCount === 5) {
						this.setState({displayCaptcha: true});
					}
					// TODO track number of failed logins on 5 captcha
				}
				this.setState({password: ''});
			})
			.catch(error => {
				console.log('error', error);
				logFetchError(error, null, null, 'fetchLoginToken')
			});
		}
		else {
			this.setState({loginError: 'You must complete the captcha'});
		}
    }

    activateEarlyHandler = (e) => {
        e.preventDefault();
        if (this.state.activateEarlyConfirmText.trim().toLowerCase() !== 'yes') {
            this.setState({ activateEarlyError: 'Please type "yes" to confirm.' });
            return;
        }
        this.setState({ activateEarlyFetchOutstanding: true, activateEarlyError: '' });
        fetch(`${this.props.route}/activateearly.webapi`, {
            method: 'POST',
            headers: {
                'Content-Type': 'text/plain',
            },
            body: JSON.stringify({
                UserName: this.state.email,
                Password: this.state.password,
            }),
        })
        .then(response => response.text())
        .then(result => {
            this.setState({
                activateEarlyFetchOutstanding: false,
                activateEarlyResponse: result,
            });
        })
        .catch(error => {
            this.setState({
                activateEarlyFetchOutstanding: false,
                activateEarlyError: 'An error occurred. Please try again or contact support.',
            });
            logFetchError(error, null, null, 'activateEarlyHandler');
        });
    }

    getTimeEarlyLabel = (activationDateStr) => {
        if (!activationDateStr) return '';
        const now = new Date();
        const activationDate = new Date(activationDateStr);
        const diffMs = activationDate - now;
        if (diffMs <= 0) return '';
        const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
        if (diffDays >= 365) {
            const years = Math.floor(diffDays / 365);
            const months = Math.floor((diffDays % 365) / 30);
            return months > 0
                ? `${years} year${years > 1 ? 's' : ''} and ${months} month${months > 1 ? 's' : ''}`
                : `${years} year${years > 1 ? 's' : ''}`;
        }
        if (diffDays >= 30) {
            const months = Math.floor(diffDays / 30);
            const days = diffDays % 30;
            return days > 0
                ? `${months} month${months > 1 ? 's' : ''} and ${days} day${days > 1 ? 's' : ''}`
                : `${months} month${months > 1 ? 's' : ''}`;
        }
        return `${diffDays} day${diffDays !== 1 ? 's' : ''}`;
    }

    formatActivationDate = (activationDateStr) => {
        if (!activationDateStr) return '';
        const date = new Date(activationDateStr);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
    }

    render() {
        return (
            <div className='loginPageWrapper'>
                <div className='login-logo'><img className='logo' src={logo} alt='CcsCases'/><div className='login-color'></div></div>
				{!this.props.production &&
					<div className='testModeWarningContainer'>
						<p className='testModeWarningText'>Test Mode</p>
					</div>
				}
                <div className={`login-screen ${!this.props.production && 'login-screen-test-background'}`}>
                    {this.state.loginPageDisplayed === 'login' ?
                        <LoginPage
                            emailChange={(e) => this.setState({email: e.target.value})}
                            passwordChange={(e) => this.setState({password: e.target.value})}
                            loginClick={this.fetchLogin}
                            forgotPasswordClick={() => this.setState({loginPageDisplayed: 'forgotPassword'})}
                            demoClick={() => this.setState({loginPageDisplayed: 'demoSignup'})}
                            viewTermsOfService={() => this.setState({loginPageDisplayed: 'termsOfService'})}
                            demoMessage={this.state.demoMessage}
                            email={this.state.email}
                            password={this.state.password}
                            loginError={this.state.loginError}
                            captcha={this.state.displayCaptcha}
                            completeCaptcha={() => this.setState({captchaCompleted: true})}
                        />
                    : this.state.loginPageDisplayed === 'forgotPassword' ?
                        <ForgotPassword
                            closeForgotPassword={() => this.setState({loginPageDisplayed: 'login'})}
                            email={this.state.email}
                            emailChange={(e) => this.setState({email: e.target.value})}
                            resetMessage={this.state.resetMessage}
                            fetchForgotPassword={this.fetchForgotPassword}
                        />
                    : this.state.loginPageDisplayed === 'termsOfService' ?
                        <TermsOfService
                            closeTermsOfService={() => this.setState({loginPageDisplayed: 'login'})}
                        />
                    : this.state.loginPageDisplayed === 'demoSignup' ?
                        <DemoSignup
                            demoError={this.state.demoError}
                            firstName={this.state.firstName}
                            lastName={this.state.lastName}
                            email={this.state.email}
                            emailConfirmation={this.state.emailConfirmation}
                            demoHear={this.state.demoHear}
                            demoMessage={this.state.demoMessage}
                            fetchDemoSignup={this.fetchDemoSignup}
                            firstNameChange={(e) => this.setState({firstName: e.target.value})}
                            lastNameChange={(e) => this.setState({lastName: e.target.value})}
                            emailChange={(e) => this.setState({email: e.target.value})}
                            demoHearChange={(e) => this.setState({demoHear: e.target.value})}
                            updateEmailConfirmation={(e) => this.setState({emailConfirmation: e.target.value})}
                            closeDemoSignup={() => this.setState({loginPageDisplayed: 'login'})}
                            otherHear={this.state.otherHear}
                            otherHearChange={(e) => this.setState({otherHear: e.target.value})}
                        />
                    : this.state.loginPageDisplayed === 'activateEarly' &&
                        <div className='activateEarlyContainer'>
                            {!this.state.activateEarlyResponse ? (
                                <form onSubmit={this.activateEarlyHandler}>
                                    <h1 className='activateEarlyHeader'>Activate Early</h1>
                                    <p className='activateEarlyBody'>
                                        Your subscription hasn&apos;t started yet. It is scheduled to be
                                        activated on{' '}
                                        <strong>{this.formatActivationDate(this.state.futureActivationDate)}</strong>{' '}
                                        You can activate it early now if you would like. This cannot be
                                        undone. Type <strong>yes</strong> if you understand.
                                    </p>
                                    <label className='activateEarlyLabel'>Confirmation</label>
                                    <input
                                        type='text'
                                        className='activateEarlyInput'
                                        placeholder='Type "yes" to confirm'
                                        value={this.state.activateEarlyConfirmText}
                                        onChange={(e) => this.setState({
                                            activateEarlyConfirmText: e.target.value,
                                            activateEarlyError: '',
                                        })}
                                        required
                                    />
                                    {!this.state.activateEarlyFetchOutstanding ? (
                                        <div className='activateEarlyButtonWrapper'>
                                            <button
                                                className='activateEarlyButton'
                                                type='button'
                                                onClick={() => this.setState({
                                                    loginPageDisplayed: 'login',
                                                    activateEarlyConfirmText: '',
                                                    activateEarlyError: '',
                                                })}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                className='activateEarlyButton activateEarlyPrimaryButton'
                                                type='submit'
                                            >
                                                Activate Now
                                            </button>
                                        </div>
                                    ) : (
                                        <div className='activateEarlyLoaderWrapper'>
                                            <div className='activateEarlySpinner' />
                                        </div>
                                    )}
                                    {this.state.activateEarlyError !== '' && (
                                        <p className='activateEarlyError'>
                                            {this.state.activateEarlyError}
                                        </p>
                                    )}
                                </form>
                            ) : (
                                <div>
                                    <h1 className='activateEarlyHeader'>Activation Complete</h1>
                                    <p className='activateEarlyBody'>
                                        {this.state.activateEarlyResponse}
                                    </p>
                                    <a
                                        className='activateEarlyButton activateEarlyPrimaryButton activateEarlyGoToLogin'
                                        href='/'
                                    >
                                        Go to Login
                                    </a>
                                </div>
                            )}
                        </div>
                    }
                </div>
				{this.state.authenticationError && <UnauthenticatedHandler />}
                {this.state.systemMessage !== '' && 
                    <div className='login-popup-message-container'>
                        <p className='login-popup-message'>{this.state.systemMessage}</p>
                        <button className='login-popup-close-button' onClick={() => this.setState({systemMessage: ''})}>X</button>
                    </div>
                }
            </div>
        )
    }
}